"use client"

import Link from "next/link"
import Image from "next/image"
import { useLanguage } from "@/lib/language-context"

export function Footer() {
  const { t } = useLanguage()
  return (
    <footer className="border-t bg-[#f4f2f0] text-[#4B4E54] py-12">


      <div className="mx-auto max-w-[98%] px-4 sm:px-6 lg:px-8">
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-5 mb-8">
          <div className="flex flex-col gap-4">
            <Link href="/" className="flex items-center gap-2">
              <Image
                src="/file.svg"
                alt="Unispare Logo"
                width={120}
                height={40}
                className="h-10 w-auto"
              />
            </Link>
            <p className="text-sm text-muted-foreground" spellCheck={false}>
              {t("hero.subtitle")}
            </p>

          </div>
          <div>
            <h3 className="font-bold mb-4">{t("footer.company")}</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">

              <li>
                <Link href="/contact" className="hover:text-foreground">
                  {t("nav.contact")}
                </Link>
              </li>

            </ul>
          </div>
          <div>
            <h3 className="font-bold mb-4">{t("nav.products")}</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <Link href="/products" className="hover:text-foreground">
                  {t("footer.all_products")}
                </Link>
              </li>
              <li>
                <Link href="/products?category=Pumps" className="hover:text-foreground">
                  {t("category.pumps")}
                </Link>
              </li>
              <li>
                <Link href="/products?category=Motors" className="hover:text-foreground">
                  {t("category.motors")}
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-bold mb-4">{t("footer.support")}</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <Link href="/faq" className="hover:text-foreground">
                  {t("nav.faq")}
                </Link>
              </li>
              <li>
                <Link href="/shipping" className="hover:text-foreground">
                  {t("products.shipping")}
                </Link>
              </li>
              <li>
                <Link href="/returns" className="hover:text-foreground">
                  {t("nav.returns")}
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-bold mb-4">{t("footer.legal")}</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <Link href="/privacy" className="hover:text-foreground">
                  {t("footer.privacy")}
                </Link>
              </li>
              <li>
                <Link href="/terms" className="hover:text-foreground">
                  {t("footer.terms")}
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t pt-8">
          <p className="text-center text-sm text-muted-foreground">© 2025 Unispare. {t("footer.rights")}</p>
        </div>
      </div>
    </footer>
  )
}
